export default __webpack_public_path__ + "static/media/owi_award_2019_web.3b2a3224.png";